/** Codes that mean Hub proof/report/certificate is not published yet — not a generic failure. */
const NOT_READY_MARKERS = [
  "client_launch_proof_not_ready",
  "launch_proof_not_available_for_client_link_status",
  "client_report_not_ready",
  "client_report_not_found",
  "current_client_report_not_found",
  "report_not_ready",
  "report_not_client_safe_ready",
  "report_not_available_for_client_link_status",
  "client_launch_certificate_not_ready",
  "launch_certificate_not_available_for_client_link_status",
  "client_portal_api_error_404",
] as const;

export function isClientEvidenceNotReadyError(codeOrMessage: string): boolean {
  const lower = codeOrMessage.trim().toLowerCase();
  return NOT_READY_MARKERS.some((marker) => lower.includes(marker));
}
